import { lookupTableReducer, ActionLookupReducer } from 'Modules/core/redux';

import { emissionActions } from './actions';
import { EmissionsReducer } from './types';


const initialState: EmissionsReducer = {
    data: null,
    isLoading: false,
    error: null,
};

const actionLookup: ActionLookupReducer<EmissionsReducer> = {
    [`${emissionActions.setEmissionLoading}`]: (state, isLoading) => ({
        ...state,
        isLoading,
    }),
    [`${emissionActions.setEmissionError}`]: (state, error) => ({
        ...state,
        isLoading: false,
        error,
    }),
    [`${emissionActions.setEmissionItems}`]: (state, data) => ({
        ...state,
        data,
    }),
};

export const reducer = lookupTableReducer(initialState, actionLookup);
